import cx from "ui/cx";
import styles from "./IconSort.module.scss";
import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

interface IconSortProps extends SvgIconProps {
  direction?: "up" | "down" | "left" | "right";
}

export default function IconSort({ direction = "down", className, ...props }: IconSortProps) {
  return (
    <SVGIcon
      className={cx(styles[direction], className)}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.33337 6L6.00004 9.33333L2.66671 6" stroke="currentColor" strokeWidth="1.5" />
      <path d="M6 1.99998L6 9.33331" stroke="currentColor" strokeWidth="1.5" />
    </SVGIcon>
  );
}
